var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block",class:{ lit: _vm.lit, hoverable: !_vm.demonstrating},style:(_vm.blockStyles)})}
var staticRenderFns = []

export { render, staticRenderFns }